(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["reservation-form-fields"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('form.contact-form').forEach((form) => {
    const body = form.querySelector('textarea[name="contact[body]"]');
    if (!body) {
      return;
    }

    form.addEventListener('submit', () => {
      const subject = form.querySelector('[data-reservation-field="subject"]')?.value || '';
      const method = form.querySelector('[data-reservation-field="method"]')?.value || '';
      const store = form.querySelector('[data-reservation-field="store"]')?.value || '';
      const message = form.querySelector('[data-reservation-field="message"]')?.value || '';
      const sex = form.querySelector('input[type="radio"]:checked')?.value || '';
      const appointmentItems = Array.from(form.querySelectorAll('[data-reservation-field="appointment_item"]:checked'))
        .map((input) => input.value)
        .join(', ');

      body.value = [
        `Subject: ${subject}`,
        `Salutation: ${sex}`,
        `Preferred contact: ${method}`,
        `Store: ${store}`,
        `Appointment items: ${appointmentItems}`,
        '',
        message,
      ].join('\n');
    });
  });
  } catch(e) { console.error(e); }
})();

})();
